var $ = jQuery;

var CART_EDT_STORAGE_KEY = "pdp_estimated_delivery_country";
var _cartEdtFetchTimer = null;
var _cartEdtInFlightKey = "";
var _cartEdtLastSuccessKey = "";
var _cartEdtViewReported = false;
var _cartEdtViewObserver = null;

function pushCartEstimatedDeliveryDatalayer(payload) {
  var body = {
    event_text: "dle_custom_event",
    event_name: payload.event_name || "",
    event_category: payload.event_category || "cart",
    event_action: payload.event_action || "",
    event_label: payload.event_label || "",
  };

  if (typeof window.datalayer_coupon_list_even_c === "function") {
    window.datalayer_coupon_list_even_c(body);
    return;
  }

  if (typeof window.klaiyiDlPush === "function") {
    window.klaiyiDlPush({
      event: body.event_text,
      dlv_en: body.event_name,
      dlv_ec: body.event_category,
      dlv_ea: body.event_action,
      dlv_el: body.event_label,
    });
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: body.event_text,
    dlv_en: body.event_name,
    dlv_ec: body.event_category,
    dlv_ea: body.event_action,
    dlv_el: body.event_label,
  });
}

function bindCartEstimatedDeliveryViewTracking($root) {
  if (_cartEdtViewReported || !$root || !$root.length) return;
  if ($root.is("[hidden]")) return;
  if (typeof IntersectionObserver !== "function") return;

  var el = $root.get(0);
  if (!el) return;

  if (_cartEdtViewObserver) {
    _cartEdtViewObserver.disconnect();
    _cartEdtViewObserver = null;
  }

  _cartEdtViewObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || _cartEdtViewReported) return;
        if ($root.is("[hidden]")) return;
        _cartEdtViewReported = true;
        pushCartEstimatedDeliveryDatalayer({
          event_name: "showDeliveryArea",
          event_category: "cart",
          event_action: "view",
          event_label: "ShowDelivery-Area",
        });
        if (_cartEdtViewObserver) {
          _cartEdtViewObserver.disconnect();
          _cartEdtViewObserver = null;
        }
      });
    },
    { threshold: 0.3 }
  );
  _cartEdtViewObserver.observe(el);
}

function cartEdtEscapeHtml(str) {
  return String(str || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function cartEdtFormatDeliveryDate(raw) {
  if (!raw) return "";
  var iso = String(raw).split("T")[0];
  var parts = iso.split("-");
  if (parts.length !== 3) return String(raw);
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var monthIndex = parseInt(parts[1], 10) - 1;
  var day = parseInt(parts[2], 10);
  if (months[monthIndex] && !isNaN(day)) {
    return months[monthIndex] + " " + day;
  }
  return String(raw);
}

function cartEdtIsDisplayBlocked(data, scene) {
  if (data == null || typeof data !== "object") return false;
  if (data.show === false || data.visible === false || data.display === false) {
    return true;
  }
  if (data.module_enabled === false || data.enabled === false) {
    return true;
  }
  if (data.reason_code != null && String(data.reason_code).trim()) {
    return true;
  }
  if (scene === "cart") {
    if (data.cart_enabled === false) return true;
    if (data.checkout_enabled === false) return true;
  }
  return false;
}

function cartEdtIsBatchResponseBlocked(res) {
  if (!res) return true;
  if (cartEdtIsDisplayBlocked(res, "cart")) return true;
  if (res.reason_code != null && String(res.reason_code).trim()) {
    return true;
  }
  var d = res.data;
  if (d != null && !Array.isArray(d) && cartEdtIsDisplayBlocked(d, "cart")) {
    return true;
  }
  return false;
}

function cartEdtHasDeliverableTime(item) {
  if (!item || typeof item !== "object") return false;
  if (cartEdtIsDisplayBlocked(item, "cart")) return false;
  var rawTime =
    item.estimated_delivery_time ||
    item.estimated_delivery_date ||
    item.delivery_date ||
    item.date ||
    "";
  return !!String(rawTime || "").trim();
}

function cartEdtParseSingleItem(item) {
  if (!cartEdtHasDeliverableTime(item)) return null;

  var rawDate =
    item.estimated_delivery_time ||
    item.estimated_delivery_date ||
    item.delivery_date ||
    item.date ||
    "";
  var deliveryDate = cartEdtFormatDeliveryDate(rawDate);
  var message =
    item.message ||
    item.text ||
    item.delivery_text ||
    item.delivery_message ||
    "";

  return {
    message: message,
    deliveryDate: deliveryDate,
    rawDate: String(rawDate).split("T")[0],
    cutoffTime:
      item.cutoff_time ||
      item.cutoffTime ||
      item.pay_before_time ||
      item.deadline_time ||
      "",
    html: item.html || item.message_html || "",
  };
}

function cartEdtParseBatchResponse(res) {
  if (!res) return null;
  if (cartEdtIsBatchResponseBlocked(res)) return null;
  var okCode =
    res.code === 200000 ||
    res.code === 20000 ||
    res.code === 200 ||
    res.success === true ||
    String(res.message || "").toLowerCase() === "success";
  if (!okCode && res.code != null) return null;

  var list = res.data;
  if (!list) return null;
  if (!Array.isArray(list)) {
    if (cartEdtIsDisplayBlocked(list, "cart")) return null;
    list = [list];
  }

  var payloads = [];
  for (var i = 0; i < list.length; i++) {
    var parsed = cartEdtParseSingleItem(list[i]);
    if (parsed) payloads.push(parsed);
  }
  if (!payloads.length) return null;

  var earliest = payloads[0];
  for (var k = 1; k < payloads.length; k++) {
    var a = earliest.rawDate || "";
    var b = payloads[k].rawDate || "";
    if (b && (!a || b < a)) earliest = payloads[k];
  }
  return earliest;
}

function cartEdtGetCountryCode($root) {
  var stored =
    typeof window.getLocalStorage === "function"
      ? window.getLocalStorage(CART_EDT_STORAGE_KEY)
      : "";
  if (stored === "US" || stored === "CA" || stored === "GB") return stored;
  var fromRoot = ($root.attr("data-default-country") || "").toUpperCase();
  if (fromRoot === "US" || fromRoot === "CA" || fromRoot === "GB") {
    return fromRoot;
  }
  if (window.Shopify && window.Shopify.country) {
    return String(window.Shopify.country).toUpperCase();
  }
  return "US";
}

var CART_EDT_MAX_VARIANT_IDS = 100;

function cartEdtNormalizeVariantId(raw) {
  if (raw == null || raw === "") return "";
  var s = String(raw).trim();
  if (!s) return "";
  if (s.indexOf("/") !== -1) {
    s = s.split("/").pop();
  }
  return /^\d+$/.test(s) ? s : "";
}

function cartEdtCollectVariantIds($root) {
  var ids = [];
  $(".CartItem[sku-id]").each(function () {
    if ($(this).hasClass("free-gift")) return;
    if ($(this).hasClass("new-customer-global-popup-gift")) return;
    if ($(this).attr("data-new-customer-global-popup-gift") === "true") return;
    var vid = cartEdtNormalizeVariantId($(this).attr("sku-id"));
    if (vid && ids.indexOf(vid) === -1) ids.push(vid);
  });
  if (ids.length > CART_EDT_MAX_VARIANT_IDS) {
    ids = ids.slice(0, CART_EDT_MAX_VARIANT_IDS);
  }
  if (ids.length) return ids.join(",");
  return ($root.attr("data-variant-ids") || "").trim();
}

function cartEdtRenderMessage($root, payload) {
  var $msg = $root.find("[data-cart-edt-message]");
  if (!$msg.length || !payload) return false;
  if (!payload.deliveryDate && !payload.html) return false;

  if (payload.html) {
    $msg.html(payload.html);
    return !!String($msg.text() || "").trim();
  }

  if (payload.message) {
    var text = payload.message;
    if (payload.deliveryDate && text.indexOf(payload.deliveryDate) !== -1) {
      var parts = text.split(payload.deliveryDate);
      $msg.html(
        cartEdtEscapeHtml(parts[0]) +
          '<span class="cart-estimated-delivery__date">' +
          cartEdtEscapeHtml(payload.deliveryDate) +
          "</span>" +
          cartEdtEscapeHtml(parts.slice(1).join(payload.deliveryDate))
      );
      return true;
    }
  }

  var cutoff = payload.cutoffTime || "5 PM";
  var date = payload.deliveryDate || "";
  if (!date) return false;
  $msg.html(
    "Pay before " +
      cartEdtEscapeHtml(cutoff) +
      ", it will be delivered as soon as " +
      '<span class="cart-estimated-delivery__date">' +
      cartEdtEscapeHtml(date) +
      "</span>"
  );
  return true;
}

function cartEdtHide($root) {
  if (!$root || !$root.length) return;
  $root.attr("hidden", "hidden");
}

function cartEdtShow($root) {
  if (!$root || !$root.length) return;
  $root.removeAttr("hidden");
  bindCartEstimatedDeliveryViewTracking($root);
}

function refreshCartEstimatedDelivery() {
  var $root = $(".cart-estimated-delivery");
  if (!$root.length) return;

  var variantIds = cartEdtCollectVariantIds($root);
  if (!variantIds) {
    cartEdtHide($root);
    return;
  }

  var countryCode = cartEdtGetCountryCode($root);
  var fetchKey = variantIds + "|" + countryCode;
  if (fetchKey === _cartEdtLastSuccessKey || fetchKey === _cartEdtInFlightKey) {
    return;
  }

  _cartEdtInFlightKey = fetchKey;
  var apiBase = window.API_BASE || "https://plugin.kriyya.com";
  var url =
    apiBase +
    "/api/klaiyi/estimated_delivery_time/batch?variant_ids=" +
    encodeURIComponent(variantIds) +
    "&country_code=" +
    encodeURIComponent(countryCode);

  fetch(url, {
    method: "GET",
    credentials: "omit",
    headers: {
      Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
    },
  })
    .then(function (res) {
      return res.json().catch(function () {
        return null;
      });
    })
    .then(function (json) {
      var payload = cartEdtParseBatchResponse(json);
      if (!payload) {
        cartEdtHide($root);
        return;
      }
      var rendered = cartEdtRenderMessage($root, payload);
      if (!rendered) {
        cartEdtHide($root);
        return;
      }
      cartEdtShow($root);
      _cartEdtLastSuccessKey = fetchKey;
      $root.attr("data-variant-ids", variantIds);
    })
    .catch(function () {
      cartEdtHide($root);
    })
    .finally(function () {
      if (_cartEdtInFlightKey === fetchKey) {
        _cartEdtInFlightKey = "";
      }
    });
}

function scheduleCartEstimatedDeliveryRefresh() {
  if (_cartEdtFetchTimer) clearTimeout(_cartEdtFetchTimer);
  _cartEdtFetchTimer = setTimeout(function () {
    _cartEdtFetchTimer = null;
    _cartEdtLastSuccessKey = "";
    refreshCartEstimatedDelivery();
  }, 150);
}

function initCartEstimatedDelivery() {
  if (window.location.pathname !== "/cart") return;
  if (!$(".cart-estimated-delivery").length) return;
  scheduleCartEstimatedDeliveryRefresh();
  document.addEventListener("cart:mutated", scheduleCartEstimatedDeliveryRefresh);
}

jQuery(function () {
  initCartEstimatedDelivery();
  initCartStock();
  // 启动默认5分钟倒计时（fiveMinuteEnd.js 须先于本文件加载）
  if (typeof startCountdownTimer === "function") {
    startCountdownTimer();
  }

  // 赠品的判断
  const isCartPage = window.location.pathname === "/cart";
  let totalQuantity = 0;
  let skus = [];
  $(".CartItem").each(function () {
    const $item = $(this);
    const $input = $item.find(".QuantitySelector__CurrentQuantity");

    const sku = $item.attr("sku-id");
    if (sku) skus.push(sku);
    if (!sku || !$input.length) return;

    const variantId = sku.split("/").pop();

    // 等下一帧再赋值，确保 input 没被 JS 替换
    setTimeout(() => {
      KlaiyiUtils.fetchVariantStock(variantId).then((stock) => {
        if (stock != null && $input.length) {
          $input.attr("data-stock", stock);
          console.log("赋值成功", $input, stock);
        }
      });
    }, 50); // 50ms 延迟即可
  });
  // $(".CartItem").each(function () {
  //   const $item = $(this);

  //   // 1️⃣ 获取数量
  //   const $input = $item.find(".QuantitySelector__CurrentQuantity");
  //   const quantity = parseInt($input.val()) || 0;
  //   totalQuantity += quantity;

  //   // 2️⃣ 隐藏价格为 0 的行
  //   const priceText = $item.find(".CartItem__Price .money").text().trim();
  //   if (priceText === "$0.00") {
  //     $item.find(".CartItem__LinePriceList").hide();
  //   }

  //   // 3️⃣ 收集 SKU
  //   const sku = $item.attr("sku-id");
  //   if (sku) skus.push(sku);

  //   // 4️⃣ 给每个商品的 input 添加 data-stock
  //   if (sku && $input.length) {
  //     console.log("购物车01", $input);
  //     // 取 variantId，假设 sku 是 "gid://shopify/ProductVariant/123456789"
  //     const variantId = sku.split("/").pop();
  //     console.log("购物车02", variantId);
  //     // 异步获取库存
  //     KlaiyiUtils.fetchVariantStock(variantId).then((stock) => {
  //       if (stock != null) {
  //         console.log("购物车03", stock);
  //         // 赋值到 input 的 data-stock 属性
  //         $input.attr("data-stock", stock);
  //       }
  //     });
  //   }
  // });

  // 页面样式调整
  $(".ProductItem__PriceList").css("position", "relative");
  $("#main").css("background", "#F6F6F6");
  if (location.pathname === "/cart") {
    updateCartCheckoutButtonState();
    document.addEventListener("cart:mutated", updateCartCheckoutButtonState);
    document.addEventListener("new-customer:gift-expired", updateCartCheckoutButtonState);
    document.addEventListener("cartGiftReady", function () {
      if (typeof window.refreshCartJsSnapshotForCheckout === "function") {
        window.refreshCartJsSnapshotForCheckout();
      }
    });
  }

  // if (isCartPage) {
  //   const isEmptyCart = $(".EmptyState").length > 0;
  //   getCartTotalPrice().then((total) => {
  //     const totalPrice = total;
  //     console.log("购物车Cart total:", total);
  //     const $checkoutBtn = $(".go_bug_button");
  //     const disableBtn = () => {
  //       $checkoutBtn
  //         .prop("disabled", true)
  //         .css({ "pointer-events": "none", opacity: "0.5" });
  //     };
  //     const enableBtn = () => {
  //       $checkoutBtn
  //         .prop("disabled", false)
  //         .css({ "pointer-events": "auto", opacity: "1" });
  //     };

  //     // 空购物车或金额为 0 禁用按钮
  //     if (isEmptyCart || totalPrice <= 0) {
  //       disableBtn();
  //     }
  //     // 过滤赠品 SKU
  //     const giftSkus = [
  //       "40358544965766",
  //       "40358547259526",
  //       "40358545129606",
  //       "40358544277638",
  //     ];
  //     const validSkus = skus.filter((sku) => !giftSkus.includes(sku));

  //     if (validSkus.length === 0 || totalPrice <= 0) {
  //       disableBtn();
  //     } else {
  //       enableBtn();
  //     }

  //     console.log("购物车总金额：$", totalPrice);
  //   });
  // }

  // 显示 Flash Sale 倒计时容器
  $(".CartItem .CartItem__Title").each(function () {
    if ($(this).find("a").text().includes("Flash Sale")) {
      $(".cart-clock").removeClass("none");
    }
  });

  // Free Gifts：仅补 class，由 CSS 隐藏数量/价格（勿 remove 节点，避免 CLS）
  $(".Cart.Cart--expanded")
    .find(".CartItem .CartItem__Info .CartItem__Title")
    .each(function () {
      const titleText = $(this).text().trim();
      if (titleText.includes("Free Gifts")) {
        $(this).closest(".CartItem").addClass("free-gift");
      }
    });

  applyQuestionnaireGiftCartItems();
  if (window.location.pathname === "/cart") {
    setTimeout(applyQuestionnaireGiftCartItems, 1500);
    setTimeout(applyQuestionnaireGiftCartItems, 3500);
  }

  // 计算并显示产品折扣百分比
  $(".CartItem").each(function () {
    const $item = $(this);
    const price1 = parseFloat($item.find(".cart_zheKou_one").text()) || 0;
    const price2 = parseFloat($item.find(".cart_zheKou_two").text()) || 0;
    if (price1 > 0 && price2 >= 0 && price2 < price1) {
      const discount = Math.round(((price1 - price2) / price1) * 100);
      $item.find(".all_discount").text(`${discount}%`);
    }
  });
});
// 进入购物车获取这个产品的库存（首次加载）
function initCartStock() {
  refreshCartItemsStock({ clampQuantity: true, resetZeroOnNoStock: true });
}

/** GraphQL 重绘购物车行后刷新 data-stock（Save 改规格后必调） */
function refreshCartItemsStock(options) {
  const opts = options || {};
  const clampQuantity = opts.clampQuantity !== false;
  const resetZeroOnNoStock = opts.resetZeroOnNoStock === true;

  const cartItems = document.querySelectorAll(".CartItem");
  cartItems.forEach((item) => {
    const variantId = item.getAttribute("sku-id");
    if (!variantId) return;

    const lineKey = item.getAttribute("data-line-key");
    if (
      typeof window.isCartLineQtyDebouncing === "function" &&
      window.isCartLineQtyDebouncing(lineKey, variantId)
    ) {
      return;
    }

    const inputs = item.querySelectorAll(".QuantitySelector__CurrentQuantity");
    if (!inputs.length) return;

    KlaiyiUtils.fetchVariantStock(variantId).then((stock) => {
      if (stock == null) return;

      inputs.forEach((input) => {
        input.dataset.stock = String(stock);

        if (!clampQuantity) return;

        let current = parseInt(input.value, 10);
        if (Number.isNaN(current)) current = 1;

        if (stock <= 0) {
          if (resetZeroOnNoStock) {
            input.value = 0;
          }
          return;
        }

        const maxLimit = Math.min(stock, 99);
        if (current > maxLimit) {
          input.value = maxLimit;
        }
        if (current < 1) {
          input.value = 1;
        }
      });
    });
  });
}

window.refreshCartItemsStock = refreshCartItemsStock;
// function initCartStock() {
//   const cartItems = document.querySelectorAll(".CartItem");

//   cartItems.forEach((item) => {
//     const variantId = item.getAttribute("sku-id");
//     if (!variantId) return;

//     const input = item.querySelector(".QuantitySelector__CurrentQuantity");
//     if (!input) return;

//     KlaiyiUtils.fetchVariantStock(variantId).then((stock) => {
//       console.log("购物车初始化库存:", variantId, stock);

//       // 存库存
//       input.dataset.stock = stock;

//       let current = parseInt(input.value, 10) || 1;

//       if (stock <= 0) {
//         input.value = 0;
//       } else {
//         const maxLimit = Math.min(stock, 99);

//         if (current > maxLimit) {
//           input.value = maxLimit;
//         }

//         if (current < 1) {
//           input.value = 1;
//         }
//       }
//     });
//   });
// }
var LEGACY_GIFT_VARIANT_IDS = [
  "40358544965766",
  "40358547259526",
  "40358545129606",
  "40358544277638",
];

function isNewCustomerGlobalPopupGiftItem(item) {
  var props = (item && item.properties) || {};
  return (
    props.newCustomerGlobalPoUpGiftProduct === "true" ||
    props.newCustomerGlobalPoUpGiftProduct === true
  );
}

function isCheckoutEligibleCartItem(item) {
  if (!item) return false;
  if (LEGACY_GIFT_VARIANT_IDS.includes(String(item.variant_id))) return false;
  if (isNewCustomerGlobalPopupGiftItem(item)) return false;

  var props = item.properties || {};
  if (props.is_gift === "true" || props.is_gift === true) return false;
  if (item.product_title && item.product_title.indexOf("Free Gifts") !== -1) {
    return false;
  }

  return true;
}

function setCartCheckoutButtonDisabled(isDisabled) {
  if (window.__checkoutNavInProgress) return;

  var $checkoutWrap = $(".go_bug_button");
  var $checkoutButton = $checkoutWrap.find(".Cart__Checkout");

  if (!$checkoutWrap.length) return;

  if (isDisabled) {
    $checkoutWrap.addClass("is-checkout-disabled");
    $checkoutButton
      .prop("disabled", true)
      .addClass("dashed")
      .attr("aria-disabled", "true");
    $checkoutWrap.css({ "pointer-events": "none", opacity: "0.5" });
    return;
  }

  $checkoutWrap.removeClass("is-checkout-disabled");
  $checkoutButton
    .prop("disabled", false)
    .removeClass("dashed")
    .attr("aria-disabled", "false");
  $checkoutWrap.css({ "pointer-events": "auto", opacity: "1" });
}

async function updateCartCheckoutButtonState() {
  if (location.pathname !== "/cart") return;
  if (window.__checkoutNavInProgress) return;
  if ($(".EmptyState").length > 0) {
    setCartCheckoutButtonDisabled(true);
    return;
  }

  try {
    var res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    var text = await res.text();
    if (text.trim().startsWith("<!DOCTYPE") || text.trim().startsWith("<html")) {
      setCartCheckoutButtonDisabled(true);
      return;
    }

    var cart = JSON.parse(text);
    var items = (cart && cart.items) || [];
    var eligibleItems = items.filter(isCheckoutEligibleCartItem);

    if (!items.length || !eligibleItems.length) {
      setCartCheckoutButtonDisabled(true);
      return;
    }

    setCartCheckoutButtonDisabled(false);
  } catch (error) {
    console.error("updateCartCheckoutButtonState failed", error);
  }
}

window.updateCartCheckoutButtonState = updateCartCheckoutButtonState;
window.setCartCheckoutButtonDisabled = setCartCheckoutButtonDisabled;

async function getCartTotalPriceSafe() {
  const res = await fetch("/cart.js", {
    headers: {
      Accept: "application/json",
    },
  });

  const text = await res.text();

  // 如果是 HTML，直接拦截
  if (text.trim().startsWith("<!DOCTYPE") || text.trim().startsWith("<html")) {
    console.warn("⚠️ /cart.js 返回 HTML，跳过解析");
    return 0;
  }

  let cart;
  try {
    cart = JSON.parse(text);
  } catch (e) {
    console.error("❌ cart.js JSON 解析失败", e);
    return 0;
  }

  return cart.total_price / 100;
}

// async function getCartTotalPrice() {
//   const cart = await fetch("/cart.js").then((res) => res.json());
//   return cart.total_price / 100;
// }

// 页面加载时检查
// document.addEventListener('DOMContentLoaded', () => {
//   window.runCartFlow(); // 直接调用
// });
document.addEventListener("DOMContentLoaded", () => {
  if (location.pathname.indexOf("/cart") !== -1) {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (typeof window.cacheCartJsSnapshot === "function") {
          window.cacheCartJsSnapshot(cart);
        }
      })
      .catch(function () {});
  }

  if (typeof window.runCartFlow !== "function") {
    console.warn("⚠️ runCartFlow 方法未定义");
    return;
  }
  // 仅赠品空态页：已静默 clear，勿再跑满赠（避免二次 DOM/reload）
  try {
    if (
      document.documentElement.getAttribute("data-cart-only-gift-clearing") ===
        "1" ||
      document.querySelector(".main_cart[data-cart-only-gift-clearing='1']") ||
      document.querySelector(".main_cart .EmptyState[data-cart-only-gift-clearing='1']")
    ) {
      return;
    }
  } catch (eOnlyGift) {}
  // 只引导一次，避免与其它入口重复跑满赠造成多余 DOM 替换
  if (window.__cartFlowBootstrapped) return;
  window.__cartFlowBootstrapped = true;
  const startCartFlow = function () {
    window.runCartFlow();
  };
  // CLS：勿 idle 2.5s 再在计分窗口内改列表；defer 脚本顺序已保证 cart-gift 先于本文件
  requestAnimationFrame(function () {
    requestAnimationFrame(startCartFlow);
  });
});

function safeJsonParseCart(value, fallback) {
  if (value == null || value === "") return fallback;
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
}

function createQuestionnaireGiftIdSet() {
  return {
    variantIds: Object.create(null),
    productIds: Object.create(null),
    handles: Object.create(null),
  };
}

function markQuestionnaireGiftReward(reward, giftIds) {
  if (!reward || !giftIds) return;
  if (reward.type !== "gift" && reward.type !== "coupon_gift") return;
  if (reward.gift_variant_id != null && reward.gift_variant_id !== "") {
    giftIds.variantIds[String(reward.gift_variant_id)] = true;
  }
  if (reward.gift_product_id != null && reward.gift_product_id !== "") {
    giftIds.productIds[String(reward.gift_product_id)] = true;
  }
  if (reward.gift_handle) {
    giftIds.handles[String(reward.gift_handle).toLowerCase()] = true;
  }
}

function collectQuestionnaireGiftIdsFromPopupManage() {
  var giftIds = createQuestionnaireGiftIdSet();
  var obj = safeJsonParseCart(sessionStorage.getItem("popuManageResponse"), null);
  if (!obj || !Array.isArray(obj.data)) return giftIds;

  var config = obj.data.find(function (item) {
    return item && item.type === "questionnaire_pop" && String(item.status) === "1";
  });
  if (!config || !config.content) return giftIds;

  var qConfig = config.content.questionnaire_config;
  if (typeof qConfig === "string") {
    qConfig = safeJsonParseCart(qConfig, null);
  }
  if (!qConfig || !Array.isArray(qConfig.reward_config)) return giftIds;

  qConfig.reward_config.forEach(function (reward) {
    markQuestionnaireGiftReward(reward, giftIds);
  });
  return giftIds;
}

function mergeQuestionnaireGiftIdsFromQuizSession(giftIds) {
  try {
    for (var i = 0; i < sessionStorage.length; i++) {
      var key = sessionStorage.key(i);
      if (!key || key.indexOf("predictWinQuiz_floatEntryRewardState_") !== 0) continue;
      var stored = safeJsonParseCart(sessionStorage.getItem(key), null);
      if (!stored) continue;

      if (stored.submitData && stored.submitData.reward) {
        markQuestionnaireGiftReward(stored.submitData.reward, giftIds);
      }
      if (Array.isArray(stored.prizes)) {
        stored.prizes.forEach(function (prize) {
          if (!prize || prize.type !== "gift") return;
          if (prize.variantId) giftIds.variantIds[String(prize.variantId)] = true;
          if (prize.productId) giftIds.productIds[String(prize.productId)] = true;
          if (prize.handle) giftIds.handles[String(prize.handle).toLowerCase()] = true;
        });
      }
    }
  } catch (e) { /* ignore */ }
  return giftIds;
}

var QUESTIONNAIRE_GIFT_PRODUCT_IDS = ["7721349218438"];

function applyHardcodedQuestionnaireGiftIds(giftIds) {
  if (!giftIds) return;
  QUESTIONNAIRE_GIFT_PRODUCT_IDS.forEach(function (id) {
    giftIds.productIds[String(id)] = true;
  });
}

function collectAllQuestionnaireGiftIds() {
  var giftIds = mergeQuestionnaireGiftIdsFromQuizSession(
    collectQuestionnaireGiftIdsFromPopupManage()
  );
  applyHardcodedQuestionnaireGiftIds(giftIds);
  return giftIds;
}

function questionnaireGiftIdSetHasValues(giftIds) {
  return (
    Object.keys(giftIds.variantIds).length > 0 ||
    Object.keys(giftIds.productIds).length > 0 ||
    Object.keys(giftIds.handles).length > 0
  );
}

function cartItemMatchesQuestionnaireGift($item, giftIds) {
  var variantId = String($item.attr("sku-id") || "");
  var productId = String($item.attr("product-id") || "");
  var handle = String($item.attr("data-product-handle") || "").toLowerCase();

  if (variantId && giftIds.variantIds[variantId]) return true;
  if (productId && giftIds.productIds[productId]) return true;
  if (handle && giftIds.handles[handle]) return true;
  return false;
}

function isZeroPriceCartItemDom($item) {
  var priceText = $item.find(".CartItem__Price .money").first().text().trim();
  if (!priceText) return false;
  return /^(\$|£|€|USD\s*)?0([.,]00)?$/.test(priceText.replace(/\s/g, ""));
}

function markQuestionnaireGiftCartItem($item) {
  if (!$item || !$item.length) return;
  $item.addClass("predict-win-quiz-cart-gift");
}

function applyQuestionnaireGiftCartItemsFromDom(giftIds, zeroPriceVariantMap) {
  if (!questionnaireGiftIdSetHasValues(giftIds)) return;

  $(".CartItem").each(function () {
    var $item = $(this);
    if ($item.hasClass("predict-win-quiz-cart-gift")) return;
    if (!cartItemMatchesQuestionnaireGift($item, giftIds)) return;

    var variantId = String($item.attr("sku-id") || "");
    if (zeroPriceVariantMap) {
      if (variantId && !zeroPriceVariantMap[variantId]) return;
    } else if (!isZeroPriceCartItemDom($item)) {
      return;
    }

    markQuestionnaireGiftCartItem($item);
  });
}

function applyQuestionnaireGiftCartItems() {
  var giftIds = collectAllQuestionnaireGiftIds();
  if (!questionnaireGiftIdSetHasValues(giftIds)) return;

  fetch("/cart.js", {
    headers: { Accept: "application/json" },
  })
    .then(function (res) {
      return res.text();
    })
    .then(function (text) {
      if (text.trim().startsWith("<!DOCTYPE") || text.trim().startsWith("<html")) {
        applyQuestionnaireGiftCartItemsFromDom(giftIds, null);
        return;
      }
      var cart = safeJsonParseCart(text, null);
      if (!cart || !Array.isArray(cart.items)) {
        applyQuestionnaireGiftCartItemsFromDom(giftIds, null);
        return;
      }

      var zeroPriceVariantMap = Object.create(null);
      cart.items.forEach(function (line) {
        if (!line) return;
        var finalPrice = line.final_price != null ? line.final_price : line.price;
        var finalLinePrice =
          line.final_line_price != null ? line.final_line_price : line.line_price;
        if (finalPrice === 0 || finalLinePrice === 0) {
          zeroPriceVariantMap[String(line.variant_id)] = true;
        }
      });

      applyQuestionnaireGiftCartItemsFromDom(giftIds, zeroPriceVariantMap);
    })
    .catch(function () {
      applyQuestionnaireGiftCartItemsFromDom(giftIds, null);
    });
}

window.applyQuestionnaireGiftCartItems = applyQuestionnaireGiftCartItems;

document.addEventListener("cart:mutated", function () {
  applyQuestionnaireGiftCartItems();
});
window.addEventListener("klaiyi:popupManageReady", function () {
  applyQuestionnaireGiftCartItems();
});

// 判断赠品弹窗的赠品是否过期开始
// 判断赠品弹窗的赠品是否过期，实时监控
function monitorGiftExpire(cartId) {
  console.log("详情赠品", cartId);
  const expireTime = localStorage.getItem("giftExpireTime");
  if (!expireTime) return; // 没有设置过赠品过期时间
  console.log("详情赠品02", cartId);
  const interval = setInterval(async () => {
    const now = Date.now();
    if (now >= parseInt(expireTime, 10)) {
      console.log("赠品已过期，清理 cart 属性...");

      // GraphQL query，value 传 null
      const query = `
        mutation {
          cartAttributesUpdate(
            cartId: "${cartId}",
            attributes: [
              { key: "stay_pop_config", value: "" }
            ]
          ) {
            cart {
              id
              attributes {
                key
                value
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      try {
        const res = await fetch(
          "https://klaiyi.myshopify.com/api/2024-04/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token":
                "825b0364aba235b72a962b67629df51d",
            },
            body: JSON.stringify({ query }),
          }
        );

        const data = await res.json();
        console.log("过期赠品清理结果:", data);

        // 清理 localStorage，避免重复请求
        localStorage.removeItem("giftExpireTime");
      } catch (err) {
        console.error("清理赠品失败:", err);
      }

      clearInterval(interval); // 清理定时器，停止监控
    }
  }, 1000); // 每秒检查一次
}

// 调用
// const cartId = window.__CART_ID__;
//获取购物车ID

async function getCartIdFromCookie() {
  const fetcher =
    typeof window.fetchCartJsWithRetry === "function"
      ? window.fetchCartJsWithRetry
      : function () {
          return fetch("/cart.js", { credentials: "same-origin" }).then(
            function (res) {
              return res.json();
            }
          );
        };
  const cart = await fetcher();
  return cart.token;
}
async function initCartId() {
  const token = await getCartIdFromCookie();
  const cartId = "gid://shopify/Cart/" + token;
  console.log("最终 购物车id:", cartId);

  // 这里调用你的过期检测
  monitorGiftExpire(cartId);
}

initCartId();

// const cartId = "gid://shopify/Cart/"+ await getCartIdFromCookie();
// console.log('cartGid', cartId);
// console.log('购物车id',cartId);
// monitorGiftExpire(cartId);

// 判断赠品弹窗的赠品是否过期结束
